$(() => {
    let sortBy = 'rating';
    $(window).on('hashchange', function() {
        if (window.location.hash) {
            var page = window.location.hash.replace('#reviews-page-', '');
            if (page == Number.NaN || page <= 0) {
                return false;
            } else {
                getReviews(page, sortBy);
            }
        }
    });
    $(document).on('click', '.js-reviews-nav .pagination a', function (e) {
        e.preventDefault();
        let productId = $(this).closest('.js-reviews').data('id');
        getReviews($(this).attr('href').split('page=')[1], sortBy, productId);
    });
    $('.js-reviews-tab .js-reviews-sort-dropdown__option').off('click').on('click', function(e) {
        e.preventDefault();
        let productId = $(this).closest('.js-information-content-tabs__el').find('.js-reviews').data('id');
        sortBy = $(this).data('value');
        $(this).parent().parent().find('.js-field-dropdown__field_btn').val($.trim($(this).children('p').text()));
        $(this).parent().removeClass('is-open');
        getReviews(1, sortBy, productId);
    });
    function getReviews(page, sort, productId) {
        $.ajax({
            url : '/products/' + productId + '/getReviews',
            data: {page:page, sortBy:sort},
            dataType: 'json'
        }).done(function (data) {
            $('.js-reviews[data-id="' + productId + '"]').html(data);
        }).fail(function (jqXHR, textStatus, errorThrown) {
        })
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/product/reviews.js